export default {
   'features': '機能',
   'downloads': 'ダウンロード',
   'roadmap': 'ロードマップ',
   'price': '価格',
   'donate': '寄付',
   'feedback': 'フィードバック',
   'panel': 'コントロールパネル',
};
